import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface DocumentDeleteStore {
  hideDeleteDocumentConfirmation: boolean;
  setHideDeleteDocumentConfirmation: (hideDeleteDocumentConfirmation: boolean) => void;
}

const initialState = {
  hideDeleteDocumentConfirmation: false,
};

export const useDocumentDeleteStore = create<DocumentDeleteStore>()(
  persist(
    (set) => ({
      ...initialState,
      setHideDeleteDocumentConfirmation: (hideDeleteDocumentConfirmation) =>
        set({ hideDeleteDocumentConfirmation }),
    }),
    {
      name: 'documentDeleteStore',
      partialize(state) {
        return {
          hideDeleteDocumentConfirmation: state.hideDeleteDocumentConfirmation,
        };
      },
    },
  ),
);
